/* ESSENTIA: guarda en Shopify los correos de la ventana de cupón (antes se perdían) */
(function () {
  function consent() {
    var f = document.getElementById('luxForm');
    if (!f || f.querySelector('.ess-consent')) return;
    var p = document.createElement('p');
    p.className = 'ess-consent';
    p.textContent = 'Al desbloquearlo te unes a ESSENTIA CLUB y recibirás novedades. Puedes darte de baja cuando quieras.';
    p.style.cssText = 'font-size:12px;color:#6e6e73;margin:12px 0 0;line-height:1.4';
    f.appendChild(p);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'luxForm') return;
    var input = f.querySelector('input[type=email]');
    if (!input || !input.value) return;
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', input.value.trim());
    body.append('contact[tags]', 'newsletter,popup-vipclub');
    try {
      fetch('/contact', { method: 'POST', body: body, keepalive: true, credentials: 'same-origin' }).catch(function () {});
    } catch (err) {}
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', consent); else consent();
})();

/* ESSENTIA: agregar rápido, mensajes de ticket promedio, mayoreo y regalo sorpresa nicho */
(function () {
  var TRAVEL = window.essTravel || null;
  var NICHO = window.essNicho || [];
  var TRAVEL_HANDLE = 'perfumero-recargable-5ml-atomizador-de-viaje-portatil-para-fragancia';
  var SORTEO = 'sin-nombre-8dic_9-18';
  var EXCLUDE = [TRAVEL_HANDLE, SORTEO];
  var MAYOREO = 3;
  var MAYOREO_URL = '/pages/mayoreo?from=cart#arma-tu-paquete';
  var GIFT_KEY = 'Regalo sorpresa';
  var GIFT_VAL = 'Sí – el pedido incluye perfume nicho';
  var GIFT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v9H5v-9"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  function drawer() { return document.querySelector('cart-drawer'); }

  function addToCart(id, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = 'Agregando…'; }
    var d = drawer();
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (d && d.getSectionsToRender) {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (btn) btn.textContent = 'Agotado'; return; }
        if (d && res.sections && d.renderContents) { d.renderContents(res); } else { window.location.href = '/cart'; }
        if (btn) btn.textContent = 'Agregado ✓';
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset.label; }, 1600);
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ess-add]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(b.getAttribute('data-ess-add'), b);
  });

  function syncGift(cart, hasNicho) {
    var cur = (cart.attributes && cart.attributes[GIFT_KEY]) || '';
    var want = hasNicho ? GIFT_VAL : '';
    if (cur === want) return;
    var attrs = {}; attrs[GIFT_KEY] = want;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0, hasTravel = false, hasNicho = false;
        cart.items.forEach(function (i) {
          if (i.handle === TRAVEL_HANDLE) hasTravel = true;
          if (EXCLUDE.indexOf(i.handle) === -1) n += i.quantity;
          if (i.handle !== SORTEO && NICHO.indexOf(i.handle) !== -1) hasNicho = true;
        });
        syncGift(cart, hasNicho);
        render(cart, n, hasTravel, hasNicho);
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function render(cart, n, hasTravel, hasNicho) {
    var d = drawer();
    if (!d) return;
    var inner = d.querySelector('.drawer__inner');
    var header = d.querySelector('.drawer__header');
    if (!inner || !header) return;
    var box = inner.querySelector('.ess-nudge');
    if (!cart.item_count) { if (box) box.remove(); return; }
    var state = n + '|' + hasTravel + '|' + hasNicho;
    if (box && box.dataset.state === state) return;
    var msg, pct, done = false;
    if (n >= MAYOREO) {
      done = true; pct = 100;
      msg = '<strong>¡Ya calificas para mayoreo!</strong> <a href="' + MAYOREO_URL + '">Cotiza tu precio especial ›</a>';
    } else if (n === 2) {
      done = true; pct = 67;
      msg = '<strong>¡Listo!</strong> Tu segunda fragancia tiene 10%. Con 1 más accedes a <a href="/pages/mayoreo">mayoreo ›</a>';
    } else if (n === 1) {
      pct = 33;
      msg = 'Agrega <strong>1 fragancia más</strong> y llévatela con 10% de descuento.';
    } else {
      pct = 0;
      msg = 'Lleva <strong>2 fragancias</strong> y la segunda tiene 10% de descuento.';
    }
    var html = '<div class="ess-nudge__bar' + (done ? ' ess-nudge__bar--done' : '') + '"><p>' + msg + '</p><div class="ess-nudge__track"><div class="ess-nudge__fill" style="width:' + pct + '%"></div></div></div>';
    if (hasNicho) {
      html += '<div class="ess-gift">' + GIFT_SVG + '<p><strong>Incluye regalo sorpresa</strong> por tu perfume nicho.</p></div>';
    }
    if (TRAVEL && !hasTravel && n > 0) {
      html += '<div class="ess-xsell">' + (TRAVEL.img ? '<img src="' + TRAVEL.img + '" alt="" loading="lazy">' : '') +
        '<div class="ess-xsell__info"><small>Llévala a todas partes</small><strong>' + TRAVEL.title + '</strong><span>' + TRAVEL.price + '</span></div>' +
        '<button class="ess-add" data-ess-add="' + TRAVEL.id + '">Agregar</button></div>';
    }
    if (!box) { box = document.createElement('div'); box.className = 'ess-nudge'; header.insertAdjacentElement('afterend', box); }
    box.dataset.state = state;
    box.innerHTML = html;
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 180); }

  function init() {
    refresh();
    var d = drawer();
    if (d) {
      new MutationObserver(function (muts) {
        for (var k = 0; k < muts.length; k++) {
          var el = muts[k].target;
          if (el.closest && el.closest('.ess-nudge')) continue;
          schedule();
          return;
        }
      }).observe(d, { childList: true, subtree: true });
    }
    var cartPage = document.querySelector('cart-items');
    if (cartPage) {
      new MutationObserver(schedule).observe(cartPage, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
